// Textos de las confirmaciones de baja dentro de un torneo.
//
// Eliminar cualquier nivel de la estructura (equipo, rueda, zona, fecha, partido)
// se lleva puesto todo lo que cuelga de él, resultados ya cargados incluidos. Nada
// se borra sin preguntar antes, y la pregunta dice exactamente qué se pierde: para
// eso están estos contadores.

// "1 zona" / "3 zonas".
export function contar(cantidad, singular, plural) {
  return cantidad + " " + (cantidad === 1 ? singular : plural);
}

// ["3 zonas", "8 partidos", "2 resultados"] -> "3 zonas, 8 partidos y 2 resultados".
// Los items vacíos (los que quedaron en cero) se descartan.
export function enumerar(partes) {
  const items = partes.filter(Boolean);
  if (items.length === 0) return "";
  if (items.length === 1) return items[0];
  return items.slice(0, -1).join(", ") + " y " + items[items.length - 1];
}

// Todos los partidos que cuelgan de una lista de fechas.
export function partidosDeFechas(matchDates = []) {
  return matchDates.flatMap((d) => d.matches || []);
}

// Todas las fechas que cuelgan de una lista de zonas.
export function fechasDeZonas(zones = []) {
  return zones.flatMap((z) => z.matchDates || []);
}

// Cuántos de esos partidos ya tienen el resultado cargado (se descarta al borrarlos).
export function jugados(matches = []) {
  return matches.filter((m) => m.jugado).length;
}

// "Se eliminan también 3 zonas, 12 fechas y 4 resultados cargados." — o "" si no
// arrastra nada (ahí el llamador pone su propio texto de "está vacía").
export function textoArrastre({ zonas = 0, fechas = 0, partidos = 0, resultados = 0 }) {
  const detalle = enumerar([
    zonas ? contar(zonas, "zona", "zonas") : "",
    fechas ? contar(fechas, "fecha", "fechas") : "",
    partidos ? contar(partidos, "partido", "partidos") : "",
    resultados ? contar(resultados, "resultado ya cargado", "resultados ya cargados") : "",
  ]);
  return detalle ? "Se eliminan también " + detalle + "." : "";
}
